/* ==========================================================================
   SEAGALE HOME — section « Lentille » : une lentille de verre s'ouvre sur chaque image.
   - Aucun scroll détourné : tout est calculé à partir de la position de la page.
   - Pas de WebGL ou mouvement réduit : pas de classe .is-gl, les images s'empilent (CSS).
   - Vidéo facultative par étape : lue seulement quand elle est visible, sinon en pause.
     Lecture bloquée (économie d'énergie, CORS) : l'image de l'étape reste affichée.
   - Éditeur de thème : réinit sur shopify:section:load, nettoyage sur unload,
     shopify:block:select amène à l'écran l'étape choisie.
   ========================================================================== */
(function () {
  if (window.SGLentille) { window.SGLentille.scan(document); return; }
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MQ = matchMedia('(max-width: 749px)');
  function cl(v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); }
  function sm(t) { t = cl(t); return t * t * (3 - 2 * t); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function back(t) { t = cl(t); var s = 1.35; t -= 1; return t * t * ((s + 1) * t + s) + 1; }
  function io3(t) { t = cl(t); return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function focal(s) { var m = String(s || '').match(/([\d.]+)%\s+([\d.]+)%/); return m ? [parseFloat(m[1]) / 100, parseFloat(m[2]) / 100] : [.5, .5]; }

  var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
  var FS = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH', 'precision highp float;', '#else', 'precision mediump float;', '#endif',
    'uniform sampler2D uA,uB;uniform vec2 uRes,uC,uImgA,uImgB;uniform vec3 uTA,uTB;',
    'uniform float uR,uBlur,uDim,uSeed,uRim,uD,uShadow,uEdge,uDeform,uGrain;',
    'vec3 NAVY=vec3(.0,.016,.11);',
    'float hash(vec2 p){return fract(sin(dot(p,vec2(12.9898,78.233))+uSeed)*43758.5453);}',
    'vec3 sA(vec2 p){return texture2D(uA,(p-uTA.yz)/(uTA.x*uImgA)).rgb;}',
    'vec3 sB(vec2 p){return texture2D(uB,(p-uTB.yz)/(uTB.x*uImgB)).rgb;}',
    'vec3 bA(vec2 p,float a){if(a<.002)return sA(p);vec3 c=vec3(0.);float j=hash(p);for(int i=0;i<10;i++){c+=sA(uC+(p-uC)*(1.-a*(float(i)+j)/10.));}return c/10.;}',
    'vec3 bB(vec2 p,float a){if(a<.002)return sB(p);vec3 c=vec3(0.);float j=hash(p+7.);for(int i=0;i<10;i++){c+=sB(uC+(p-uC)*(1.-a*(float(i)+j)/10.));}return c/10.;}',
    'void main(){',
    ' vec2 px=vec2(gl_FragCoord.x,uRes.y*uD-gl_FragCoord.y)/uD;vec2 d=px-uC;float r=length(d);float R=max(uR,.001);float n=r/R;',
    ' vec3 a=bA(px,uBlur*.1);a=mix(a,a*.42+NAVY*.08,uDim);vec3 col=a;float aa=1.2;',
    ' float sh=smoothstep(R*1.2,R*.92,length(d-vec2(R*.03,R*.07)))*uRim;col*=1.-uShadow*sh;',
    ' if(r<R+aa){',
    '  float bul=mix(1.,1.+.09*uDeform*pow(n,14.),uRim);float ab=.01*uDeform*pow(n,10.)*uRim+uBlur*.004;',
    '  vec3 g;vec2 q=uC+d*bul;',
    '  if(uBlur>.02){g=bB(q,uBlur*.1);}else{g=vec3(sB(uC+d*(bul+ab)).r,sB(q).g,sB(uC+d*(bul-ab)).b);}',
    '  g*=1.-.12*smoothstep(.95,1.,n)*uRim;',
    '  g+=smoothstep(.985,1.,n)*uEdge*uRim*vec3(1.,.97,.9);',
    '  col=mix(g,col,smoothstep(R-aa,R+.2,r));',
    ' }',
    ' vec2 v=(px/uRes-.5)*1.35;col*=1.-.16*dot(v,v);',
    ' col+=(hash(px)-.5)*.072*uGrain;',
    ' gl_FragColor=vec4(col,1.);',
    '}'].join('\n');

  function GLR(cv) {
    var gl;
    try { gl = cv.getContext('webgl', { antialias: false, alpha: false }); } catch (e) { return null; }
    if (!gl) return null;
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; }
    var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS); if (!vs || !fs) return null;
    var pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return null;
    gl.useProgram(pr);
    var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var la = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(la); gl.vertexAttribPointer(la, 2, gl.FLOAT, false, 0, 0);
    var U = {}; ['uA', 'uB', 'uRes', 'uC', 'uImgA', 'uImgB', 'uTA', 'uTB', 'uR', 'uBlur', 'uDim', 'uSeed', 'uRim', 'uD', 'uShadow', 'uEdge', 'uDeform', 'uGrain'].forEach(function (n) { U[n] = gl.getUniformLocation(pr, n); });
    gl.uniform1i(U.uA, 0); gl.uniform1i(U.uB, 1);
    return { gl: gl, U: U };
  }
  function makeTex(gl, im) {
    var t = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, t);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, im);
    return t;
  }

  var ZONES = ['tl', 'tc', 'tr', 'ml', 'mc', 'mr', 'bl', 'bc', 'br'];

  function Lens(sec) {
    var A = function (n) { return parseFloat(sec.getAttribute('data-' + n)); };
    var cv = sec.querySelector('.sgl-gl'), hud = sec.querySelector('.sgl-hud'), hc = hud.getContext('2d'), pin = sec.querySelector('.sgl-pin');
    var G = GLR(cv); if (!G) return null;
    var gl = G.gl, U = G.U;
    var steps = [].slice.call(sec.querySelectorAll('.sgl-s')).filter(function (s) { return s.hasAttribute('data-d'); }).map(function (s) {
      var lg = s.querySelector('.sgl-lg');
      return { el: s, lg: lg, lgB: lg && lg.querySelector('.sgl-lg-b'), big: lg && lg.querySelector('.sgl-lg-b') ? lg.querySelector('.sgl-lg-b').textContent : '', els: [], tex: null, w: 0, h: 0, vid: null, vtex: null, vOk: false, vBlocked: false, vT: -1 };
    });
    if (steps.length < 2) return null;
    var dead = false, W = 0, H = 0, D = 1, cur = -1, tgt = 0, raf = 0, started = false, loadGen = 0;
    sec.classList.add('is-gl');

    /* range chaque texte dans sa zone selon l'écran */
    function layout() {
      var ph = MQ.matches, key = ph ? 'data-pm' : 'data-pd';
      steps.forEach(function (st) {
        st.els = [].slice.call(st.el.querySelectorAll('.sgl-e')).map(function (e) {
          return { e: e, w: e.getAttribute('data-w') || 'image', in: e.querySelector('.sgl-in'), sub: e.querySelector('.sgl-sub') };
        });
        var zs = {};
        ZONES.forEach(function (z) {
          var d = st.el.querySelector(':scope > .sgl-z--' + z);
          if (!d) { d = document.createElement('div'); d.className = 'sgl-z sgl-z--' + z; st.el.appendChild(d); }
          zs[z] = d;
        });
        st.els.forEach(function (o) { var z = o.e.getAttribute(key) || 'bl'; (zs[z] || zs.bl).appendChild(o.e); });
        if (st.lg) {
          var lz = st.lg.getAttribute(key) || 'auto';
          st.auto = lz === 'auto';
          st.lg.classList.toggle('is-auto', st.auto);
          if (st.auto) st.el.appendChild(st.lg); else (zs[lz] || zs.bl).appendChild(st.lg);
        }
        /* base.css masque les div vides : rien à faire, une zone vide doit rester invisible */
      });
    }

    function size() {
      var b = pin.getBoundingClientRect(); W = b.width; H = b.height; D = Math.min(1.5, window.devicePixelRatio || 1);
      cv.width = W * D; cv.height = H * D; hud.width = W * D; hud.height = H * D; gl.viewport(0, 0, cv.width, cv.height);
      var ph = MQ.matches, len = A(ph ? 'step-m' : 'step-d') || 130;
      sec.style.height = ((steps.length - 1) * len + 140) + 'svh';
    }

    function dropVideo(st) {
      if (st.vid) { st.vid.pause(); st.vid.removeAttribute('src'); st.vid.load(); st.vid = null; }
      if (st.vtex) { gl.deleteTexture(st.vtex); st.vtex = null; }
      st.vOk = false; st.vBlocked = false; st.vT = -1;
    }
    function loadVideo(st, ph) {
      var url = st.el.getAttribute(ph ? 'data-vm' : 'data-vd'); if (!url) return;
      st.fv = focal(st.el.getAttribute(ph ? 'data-vfm' : 'data-vfd'));
      var v = document.createElement('video');
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
      v.crossOrigin = 'anonymous'; v.preload = 'auto';
      v.addEventListener('error', function () { st.vBlocked = true; });
      v.addEventListener('loadeddata', function () { if (dead || st.vid !== v) return; st.vOk = true; req(); });
      st.vid = v; v.src = url; v.load();
    }
    /* copie l'image courante de la vidéo dans sa texture, seulement si elle a changé */
    function upload(st) {
      var v = st.vid;
      if (!v || !st.vOk || st.vBlocked || v.readyState < 2 || v.currentTime === st.vT) return;
      try {
        gl.activeTexture(gl.TEXTURE2);
        if (!st.vtex) { st.vtex = makeTex(gl, v); } else { gl.bindTexture(gl.TEXTURE_2D, st.vtex); gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, v); }
        st.vT = v.currentTime;
      } catch (e) { st.vBlocked = true; if (st.vtex) { gl.deleteTexture(st.vtex); st.vtex = null; } if (window.console) console.warn('Lentille : vidéo non lisible, image conservée.', e); }
    }
    function want(st, on) {
      var v = st.vid; if (!v || st.vBlocked) return;
      if (on && v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function (e) { if (e && e.name === 'NotAllowedError') st.vBlocked = true; }); }
      else if (!on && !v.paused) v.pause();
    }
    function pauseAll() { steps.forEach(function (st) { want(st, false); }); }
    /* source à afficher : la vidéo si elle est prête, sinon l'image */
    function pick(st) {
      if (st.vtex && !st.vBlocked) return { tex: st.vtex, w: st.vid.videoWidth, h: st.vid.videoHeight, f: st.fv };
      return { tex: st.tex, w: st.w, h: st.h, f: st.f };
    }

    function load() {
      started = true; var gen = ++loadGen, ph = MQ.matches;
      steps.forEach(function (st) {
        if (st.tex) { gl.deleteTexture(st.tex); st.tex = null; }
        dropVideo(st); loadVideo(st, ph);
        st.f = focal(st.el.getAttribute(ph ? 'data-fm' : 'data-fd'));
        var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
        im.onload = function () {
          if (dead || gen !== loadGen) return;
          try { st.tex = makeTex(gl, im); st.w = im.naturalWidth; st.h = im.naturalHeight; req(); }
          catch (e) { fail(); }
        };
        im.src = st.el.getAttribute(ph ? 'data-m' : 'data-d');
      });
    }
    function fail() { destroy(); sec.classList.remove('is-gl'); sec.style.height = ''; }

    function coverT(st, s) {
      var i = st.w, j = st.h, f = st.f;
      var k = Math.max(W / i, H / j) * s, dw = i * k, dh = j * k, ox = W / 2 - dw * f[0], oy = H / 2 - dh * f[1];
      if (s >= 1) { ox = Math.min(0, Math.max(W - dw, ox)); oy = Math.min(0, Math.max(H - dh, oy)); }
      return [k, ox, oy, i, j];
    }

    function render(p) {
      var ph = MQ.matches, N = steps.length - 1;
      var q = cl(p / .9) * N, i = Math.min(N - 1, Math.floor(q)), f = q - i; if (p >= .9) { i = N - 1; f = 1; }
      var a = steps[i], b = steps[i + 1];
      var perso = sec.getAttribute(ph ? 'data-lens-m' : 'data-lens-d') === 'perso';
      var cn = perso ? [parseFloat(b.el.getAttribute(ph ? 'data-xm' : 'data-xd')) / 100, parseFloat(b.el.getAttribute(ph ? 'data-ym' : 'data-yd')) / 100] : (ph ? [.5, .34] : [.5, .46]);
      var cx = W * cn[0], cy = H * cn[1], R0 = Math.min(W, H) * (A(ph ? 'size-m' : 'size-d') || 27) / 100;
      var dg = Math.hypot(Math.max(cx, W - cx), Math.max(cy, H - cy)) * 1.04;
      var o = cl((f - .15) / .2), gr = io3((f - .66) / .34), R = lerp(R0 * back(o), dg, gr);
      var rim = 1 - sm((gr - .2) / .4), blur = Math.sin(Math.PI * gr) * (A('blur') / 100), dim = sm(o * 1.4) * .85;
      /* seules les vidéos visibles tournent */
      var showA = gr < 1, showB = f > .08;
      steps.forEach(function (st) { want(st, (st === a && showA) || (st === b && showB)); });
      if (showA) upload(a); if (showB) upload(b);
      var sa = pick(a), sb = pick(b);
      if (sa.tex && sb.tex) {
        var ta = coverT(sa, 1 + .05 * f + .22 * gr), tb = coverT(sb, lerp(1.36 - .05 * sm((f - .3) / .4), 1, gr));
        gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, sa.tex); gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, sb.tex);
        gl.uniform2f(U.uRes, W, H); gl.uniform1f(U.uD, D); gl.uniform2f(U.uC, cx, cy);
        gl.uniform2f(U.uImgA, ta[3], ta[4]); gl.uniform2f(U.uImgB, tb[3], tb[4]); gl.uniform3f(U.uTA, ta[0], ta[1], ta[2]); gl.uniform3f(U.uTB, tb[0], tb[1], tb[2]);
        gl.uniform1f(U.uR, R); gl.uniform1f(U.uBlur, blur); gl.uniform1f(U.uDim, dim); gl.uniform1f(U.uSeed, (p * 91.7) % 7); gl.uniform1f(U.uRim, rim);
        gl.uniform1f(U.uShadow, A('shadow') / 100); gl.uniform1f(U.uEdge, A('edge') / 100); gl.uniform1f(U.uDeform, A('deform') / 100); gl.uniform1f(U.uGrain, A('grain') / 100);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      }

      /* textes */
      var lv = sm((f - .34) / .07) * (1 - sm((f - .62) / .05));
      steps.forEach(function (st, j) {
        var img = 0;
        if (j === i) img = 1 - sm((f - .13) / .06);
        if (j === i + 1) img = sm((f - .92) / .07);
        var lens = j === i + 1 ? lv : 0;
        st.els.forEach(function (o2) {
          var v = o2.w === 'lens' ? lens : o2.w === 'all' ? Math.max(img, lens) : img;
          o2.e.style.visibility = v > .002 ? 'visible' : 'hidden';
          if (o2.in) { o2.e.style.opacity = v > .002 ? 1 : 0; o2.in.style.transform = 'translateY(' + ((1 - v) * 105).toFixed(2) + '%)'; }
          else { o2.e.style.opacity = sm((v - .35) / .65).toFixed(3); }
          if (o2.sub) o2.sub.style.letterSpacing = lerp(.34, .1, v).toFixed(3) + 'em';
        });
        if (st.lg) st.lg.style.visibility = j === i + 1 && lv > .002 ? 'visible' : 'hidden';
      });

      /* légende et trait */
      hc.setTransform(D, 0, 0, D, 0, 0); hc.clearRect(0, 0, W, H);
      if (b.lg && lv > .002) {
        b.lg.style.opacity = lv.toFixed(3);
        if (b.lgB) {
          var m = b.big.match(/\d[\d\s  ]*/);
          if (m) { var tot = parseInt(m[0].replace(/\D/g, ''), 10), c = Math.round(lerp(1, tot, Math.pow(sm((f - .34) / .1), 2))); if (c >= 100) c = Math.round(c / 10) * 10; if (c === Math.round(tot / 10) * 10) c = tot; b.lgB.textContent = b.big.replace(m[0], c.toLocaleString(document.documentElement.lang || 'fr') + (/\s$/.test(m[0]) ? ' ' : '')); }
        }
        if (b.auto) {
          var lw = b.lg.offsetWidth, lh = b.lg.offsetHeight, side = ph ? 0 : (cn[0] > .58 ? -1 : cn[0] < .42 ? 1 : 0);
          if (!ph && side === 0 && cy + R0 + 26 + lh + 20 > H) side = 1;
          var flip = side === 0 && cy + R0 + 26 + lh + 20 > H;
          var ang = side === 0 ? (flip ? -Math.PI / 2 : Math.PI / 2) : (side < 0 ? Math.PI * 1.2 : -Math.PI * .2);
          var sx = cx + Math.cos(ang) * (R0 + 4), sy = cy + Math.sin(ang) * (R0 + 4), ex, ey;
          if (side === 0) { ex = sx; ey = sy + (flip ? -26 : 26); } else { ex = sx + side * Math.min(46, W * .04); ey = sy - Math.min(26, H * .03); }
          var tp = sm((f - .34) / .05), lx, ly;
          hc.strokeStyle = getComputedStyle(sec).getPropertyValue('--sgl-accent') || '#C9B48E'; hc.lineWidth = 1; hc.globalAlpha = lv;
          hc.beginPath(); hc.moveTo(sx, sy); hc.lineTo(lerp(sx, ex, tp), lerp(sy, ey, tp)); hc.stroke(); hc.globalAlpha = 1;
          if (side === 0) { b.lg.style.textAlign = 'center'; lx = ex - lw / 2; ly = flip ? ey - lh - 6 : ey + 6; }
          else { b.lg.style.textAlign = side < 0 ? 'right' : 'left'; lx = side < 0 ? ex - lw - 8 : ex + 8; ly = ey - lh * .4; }
          lx = cl(lx, 12, W - lw - 12); ly = cl(ly, 44, H - lh - 10);
          b.lg.style.transform = 'translate(' + lx.toFixed(1) + 'px,' + (ly + (1 - lv) * 10).toFixed(1) + 'px)';
        }
      }
    }

    function target() { var r = sec.getBoundingClientRect(); return cl(-r.top / Math.max(1, r.height - innerHeight)); }
    function exitFx() {
      var r = sec.getBoundingClientRect(), on = sec.getAttribute(MQ.matches ? 'data-px-m' : 'data-px') !== '0';
      var e = on ? cl(1 - r.bottom / innerHeight) : 0;
      pin.style.transform = e > 0 ? 'translateY(' + (e * innerHeight * .6).toFixed(1) + 'px) scale(' + (1 + e * .15).toFixed(3) + ')' : '';
      pin.style.filter = e > 0 ? 'brightness(' + (1 - e * .7).toFixed(3) + ')' : '';
    }
    /* scroll amorti : l'image rattrape le scroll */
    function loop() {
      raf = 0; if (dead) return;
      var r = sec.getBoundingClientRect();
      if (r.bottom < -40 || r.top > innerHeight + 40) { pauseAll(); return; }
      tgt = target(); exitFx();
      var nx = cur < 0 ? tgt : cur + (tgt - cur) * .14; if (Math.abs(tgt - nx) < .0004) nx = tgt;
      cur = nx; render(nx);
      var playing = steps.some(function (st) { return st.vid && !st.vBlocked && !st.vid.paused; });
      if (nx !== tgt || playing) raf = requestAnimationFrame(loop);
    }
    function req() { if (!raf && !dead) raf = requestAnimationFrame(loop); }
    function onResize() { size(); cur = -1; req(); }
    function onMq() { layout(); size(); load(); cur = -1; req(); }
    addEventListener('scroll', req, { passive: true }); addEventListener('resize', onResize);
    if (MQ.addEventListener) MQ.addEventListener('change', onMq);
    var ro = 'ResizeObserver' in window ? new ResizeObserver(function () { size(); req(); }) : null; if (ro) ro.observe(pin);
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting && !started) load(); if (x.isIntersecting) req(); }); }, { rootMargin: '150% 0px' }); io.observe(sec);

    function destroy() {
      dead = true; removeEventListener('scroll', req); removeEventListener('resize', onResize);
      if (MQ.removeEventListener) MQ.removeEventListener('change', onMq);
      if (ro) ro.disconnect(); io.disconnect();
      steps.forEach(dropVideo);
      var ext = gl.getExtension('WEBGL_lose_context'); if (ext) ext.loseContext();
    }
    layout(); size(); req();
    return {
      destroy: destroy, relayout: function () { layout(); cur = -1; req(); },
      select: function (blockEl) {
        var s = blockEl.closest('.sgl-s'), k = -1; steps.forEach(function (st, j) { if (st.el === s) k = j; }); if (k < 0) return;
        var N = steps.length - 1, inLens = blockEl.closest('.sgl-e') ? blockEl.closest('.sgl-e').getAttribute('data-w') === 'lens' : false;
        var q = k === N && !inLens ? 1 : ((inLens && k > 0 ? k - 1 + .5 : k + .05) / N) * .9;
        var top = sec.getBoundingClientRect().top + scrollY; scrollTo({ top: top + q * Math.max(0, sec.offsetHeight - innerHeight), behavior: 'instant' });
      }
    };
  }

  var live = new Map();
  function init(sec) {
    if (live.has(sec) || RM) return;
    var l = Lens(sec); if (l) live.set(sec, l);
  }
  function scan(root) { [].forEach.call((root || document).querySelectorAll('[data-sgl]'), init); }
  window.SGLentille = { scan: scan, version: '1.1.0' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { var s = e.target.querySelector('[data-sgl]'); if (s && live.has(s)) { live.get(s).destroy(); live.delete(s); } });
  document.addEventListener('shopify:block:select', function (e) { var s = e.target.closest && e.target.closest('[data-sgl]'); if (s && live.has(s)) { live.get(s).relayout(); live.get(s).select(e.target); } });
})();
